import { useTranslation } from '@lyearn/i18n';
import { PlusFill, SparkleOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { BaseIconButton, Stack, Tooltip, Typography } from '@lyearn/ui';
import useAnalytics from '@/components/Analytics/hooks/useAnalytics';
import { aiActionButtonStyles } from '@/components/LyearnAI/components/AskAIButton/styles';
import stopPropagation from '@/consts/stopPropogation';

const AIAddBlock = ({
  onAddOption,
  onShowAISuggestions,
}: {
  onAddOption: () => void;
  onShowAISuggestions: () => void;
}) => {
  const { t } = useTranslation(['AI']);
  const { track } = useAnalytics();

  return (
    <Stack
      alignItems="start"
      className="flex w-full items-center justify-center rounded-8 border border-dashed border-border-dark py-10 pe-10 ps-12"
      role="button"
      onClick={onAddOption}>
      <Stack alignItems="center">
        <PlusFill className="h-24 w-24 me-16" fillColorToken="icon-placeholder" />
        <Typography color="text-text-placeholder" variant="body-short-01">
          {t('QuizCreator:AddOption')}
        </Typography>
      </Stack>
      <Tooltip
        componentsProps={{ tooltip: { className: 'w-[135px] text-center' } }}
        title={t('AI:Quiz.GenerateIncorrectOptions') || ''}>
        <BaseIconButton
          className={cn(aiActionButtonStyles, 'h-24 w-24 p-0 ms-auto')}
          onClick={(ev) => {
            track('Generate incorrect option');
            stopPropagation(ev);
            onShowAISuggestions();
          }}>
          <SparkleOutline className="sparkle-icon h-16 w-16" />
        </BaseIconButton>
      </Tooltip>
    </Stack>
  );
};

export default AIAddBlock;
